export default "__VITE_ASSET__DHcauwS5__"